import { Component, OnInit, HostBinding } from '@angular/core';
import { MetaService } from 'app/services/meta.service';
import { BaseComponent } from '../base/base.component';
import { FragmentService } from '../../services/fragment.service';

@Component({
  selector: 'product-landing, app-product-landing',
  templateUrl: './product-landing.component.html',
  standalone: false
})
export class ProductLandingComponent extends BaseComponent implements OnInit {
  @HostBinding('class.-version-2') isVersion2 = false;

  constructor(
    public fragmentService: FragmentService,
    public metaService: MetaService
  ) {
    super(fragmentService, metaService);
  }

  ngOnInit(): void {
    if (this.meta['template-version'] === 'alternate') {
      this.isVersion2 = true;
    }
  }
}
